<template>
  <div class="md-layout md-alignment-top-center">

    <div class="md-layout-item md-size-60 md-small-size-100">

      <md-card>

        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>description</md-icon>
          </div>

          <div>
            <h4 class="title">Create Utilization Sheet</h4>
            <p class="category">
              Create a utilization sheet for a selected vendor and department
            </p>
          </div>
        </md-card-header>

        <form @submit.prevent="add">

          <md-card-content>

            <!-- Vendor & Department -->
            <div class="md-layout">

              <div class="md-layout-item md-size-50 md-small-size-100">

                <label class="field-label">
                  Vendor
                </label>

                <v-select
                    v-model="invoice.vendor_id"
                    :options="vendors"
                    label="name"
                    :reduce="item => item.id"
                    placeholder="Select Vendor"
                    clearable
                />

                <validation-error
                    :errors="apiValidationErrors.vendor_id"
                />

              </div>

              <div class="md-layout-item md-size-50 md-small-size-100">

                <label class="field-label">
                  Department
                </label>

                <v-select
                    v-model="invoice.department_id"
                    :options="departments"
                    label="name"
                    :reduce="item => item.id"
                    placeholder="Select Department"
                    clearable
                />

                <validation-error
                    :errors="apiValidationErrors.department_id"
                />

              </div>

            </div>

            <!-- Guidance Type -->
            <div class="md-layout mt-20">
              <div class="md-layout-item md-size-50 md-small-size-100">

              <label class="field-label">
                Guidance Type
              </label>

              <div class="radio-group">

                <md-radio
                    v-model="invoice.guidance_type"
                    value="Per Man Hour"
                >
                  Per Man Hour
                </md-radio>

                <md-radio
                    v-model="invoice.guidance_type"
                    value="Per Work Done"
                >
                  Per Work Done
                </md-radio>

              </div>

              <validation-error
                  :errors="apiValidationErrors.guidance_type"
              />

              </div>
              <!-- Pay code -->
              <div class="md-layout-item md-size-50 md-small-size-100">

                <label class="field-label">
                  Pay Code
                </label>

                <div class="radio-group" v-if="invoice.guidance_type==='Per Work Done'">

                  <md-radio
                      v-model="invoice.pay_code"
                      value="PT"
                  >
                    Per Tonnage (PT)
                  </md-radio>

                  <md-radio
                      v-model="invoice.pay_code"
                      value="PU"
                  >
                    Per Unit (PU)
                  </md-radio>
                  <md-radio
                      v-model="invoice.pay_code"
                      value="TU"
                  >
                    Per TEUs (TU)
                  </md-radio>

                </div>
                <div class="radio-group" v-if="invoice.guidance_type==='Per Man Hour'">

                  <md-radio
                      v-model="invoice.pay_code"
                      value="MH"
                  >
                    Man Hour (MH)
                  </md-radio>

                </div>

                <validation-error
                    :errors="apiValidationErrors.pay_code"
                />

              </div>
              <!-- Time Clock Status -->
              <div class="md-layout-item md-size-50 md-small-size-100">

                <label class="field-label">
                  Time Clock Status
                </label>

                <v-select
                    v-model="invoice.time_clock_status"
                    :options="timeClockStatuses"
                    label="name"
                    :reduce="item => item.id"
                    placeholder="Select Time Clock Status"
                    clearable
                />

                <validation-error
                    :errors="apiValidationErrors.time_clock_status"
                />

              </div>

            </div>


            <!-- Date Range -->
            <div class="md-layout mt-20">

              <div class="md-layout-item md-size-50 md-small-size-100">

                <md-datepicker
                    v-model="invoice.start_date"
                    :md-disabled-dates="disabledDates"
                    :md-model-type="String"
                    md-immediately
                >
                  <label>Start Date</label>
                </md-datepicker>

                <validation-error
                    :errors="apiValidationErrors.start_date"
                />

              </div>

              <div class="md-layout-item md-size-50 md-small-size-100">

                <md-datepicker
                    v-model="invoice.end_date"
                    :md-disabled-dates="disabledDates"
                    :md-model-type="String"
                    md-immediately
                >
                  <label>End Date</label>
                </md-datepicker>

                <validation-error
                    :errors="apiValidationErrors.end_date"
                />

              </div>

            </div>

            <!-- Summary -->
            <div
                v-if="
                invoice.vendor_id ||
                invoice.department_id ||
                invoice.guidance_type ||
                invoice.pay_code
              "
                class="summary-box"
            >

              <div>
                <strong>Vendor:</strong>
                {{ selectedVendor }}
              </div>

              <div>
                <strong>Department:</strong>
                {{ selectedDepartment }}
              </div>

              <div>
                <strong>Type:</strong>
                {{ invoice.guidance_type || '-' }}
                ( {{ invoice.pay_code || '-' }})
              </div>
              <div>
                <strong>Time Clock Status:</strong>
                {{ invoice.time_clock_status || '-' }}
              </div>

            </div>

          </md-card-content>

          <md-card-actions>

            <md-button
                class="md-simple"
                @click="goBack"
            >
              Cancel
            </md-button>

            <md-button
                type="submit"
                class="md-success"
                :disabled="isLoading"
            >
              Create Utilization Sheet
            </md-button>

          </md-card-actions>

        </form>

      </md-card>

    </div>

  </div>
</template>

<script>
import { ValidationError } from '@/components';
import formMixin from '@/mixins/form-mixin';
// import Multiselect from 'vue-multiselect';
import SelectInputHorizontal from '../../../components/Inputs/SelectInputHorizontal';
import Vuex from "vuex";

export default {
    components: { ValidationError,SelectInputHorizontal },

    mixins: [formMixin],

    data: () => ({
        guidaceTypes: [
            { 'id':'Per Man Hour','name': 'Per Man Hour' },
            { 'id':'Per Work Done','name': 'Per Work Done', },
        ],
      timeClockStatuses: [
        {
          id: 'Assigned',
          name: 'Assigned'
        },
        {
          id: 'Supervisor_Checked_In',
          name: 'Supervisor Checked In'
        },
        {
          id: 'Checked_Out',
          name: 'Checked Out'
        },
        {
          id: 'Supervisor_Checked_Out',
          name: 'Supervisor Checked Out'
        }
      ],
        invoice: {
            type: 'invoices',
            invoice_number: null,
          vendor_id: null,
          department_id: null,
          pay_code: null,
            // guidance_id: null,
            payment_mode: null,
            // invoice_type:null,
            start_date:null,
            end_date:null,
          time_clock_status: 'Supervisor_Checked_Out',
        },
      user_station: {},
      vendors: [],
      departments: [],
        isLoading: false,
        default_value: { id: '', name: 'Select Guidance' },
        available_guidances:[],
        disabledDates: date => {
            return date > new Date().setHours(0, 0, 0, 0);
        },
    }),
    created () {
        this.getVendors();
        this.getDepartments();
    },
watch:{
  me: {
    handler: function (val) {
      if (val != null) {
        this.user_station = val.model.department.station;
        this.getVendors();
      }
    },
    deep: true,
    immediate: true,
  },
  async 'invoice.vendor_id'(vendorId) {
    this.invoice.department_id = null;

    if (vendorId) {
      await this.getDepartments(vendorId);
    } else {
      await this.getDepartments();
    }
  },
  'invoice.guidance_type'(value) {
    if (value === 'Per Man Hour') {
      // Man Hour must always use MH
      this.invoice.pay_code = 'MH';
    } else if (value === 'Per Work Done') {
      // Default to PT when switching to Work Done
      this.invoice.pay_code = 'PT';
    } else {
      this.invoice.pay_code = null;
    }
  }
},
  computed:{
    ...Vuex.mapState({
      me: state => state.profile.me
    }),
    selectedVendor () {
      const item = this.vendors.find( v => v.id === this.invoice.vendor_id )
      return item ? item.name : '-'
    },
    selectedDepartment () {
      const item = this.departments.find( d => d.id === this.invoice.department_id )
      return item ? item.name : '-'
    }
  },
    methods: {
      async getDepartments (vendorId = null) {

        const params = {
          filter: {
            ...(vendorId ? { vendor: vendorId } : {}),
          },
        };

        await this.$store.dispatch(
            'departments/list',
            params
        );

        this.departments =
            this.$store.getters['departments/dropdown'];
      },

      async getVendors () {
        let vendorParams = { filter: { 'station': '' } };
        let station = this.user_station ? this.user_station : null;
        if (typeof station !== 'undefined' && station != null) {
          vendorParams.filter.station = station.id;
        } else {
          vendorParams = null;
        }
        await this.$store.dispatch('vendors/list',vendorParams);
        this.vendors =
            this.$store.getters['vendors/dropdown'];
      },

      async add() {
        try {
          const payload = {
            ...this.invoice,
            vendor_id: this.invoice.vendor_id,
            department_id: this.invoice.department_id,
          };

          await this.$store.dispatch('invoices/add', payload);

          this.notifySuccess('Utilization Sheet added successfully.');
          this.goBack();
        } catch (e) {
          if (e.response?.data?.errors?.length) {
            this.notifyError(e.response.data.errors[0].detail);
            this.setApiValidation(e.response.data.errors);
          } else {
            this.notifyError('Oops, something went wrong!');
          }
        }
      },

        goBack () {
            this.$router.push({ name: 'Utilization Sheet List' });
        },
    },
};
</script>

<style scoped>

.field-label {
  display: block;
  font-weight: 600;
  margin-bottom: 8px;
}

.mt-20 {
  margin-top: 20px;
}

.radio-group {
  display: flex;
  gap: 25px;
  align-items: center;
}

.summary-box {
  margin-top: 20px;
  padding: 12px 15px;
  border-radius: 6px;
  background: #f7f7f7;
  border-left: 4px solid #4caf50;
}

.summary-box div {
  margin-bottom: 4px;
}

.summary-box div:last-child {
  margin-bottom: 0;
}

</style>

